<template>
    <v-container>
        <!-- <v-dialog
            v-model="changeFotoDialog"
            width="80%"
            max-width="400px"
        >
            <v-card>
                <v-card-title color="primary">
                    {{ $t('homePassageiro.dialogs.changePhoto.title') }}
                </v-card-title>
                <v-card-text>
                    <v-file-input :label="$t('homePassageiro.dialogs.changePhoto.selectPhoto')"
                        prepend-icon="mdi-camera" show-size truncate-length="15" accept="image/png, image/jpeg"
                        v-model="novaFotoFile" @change="onFileChanged"></v-file-input>
                    <v-img :src="novaFoto" height="200px" width="200px" min-height="100px" min-width="100px"
                        style="padding: 10px; margin: 5px; border: 1px solid #4a4a4a; border-radius: 5px; box-shadow: #4a4a4a 1px 1px 5px; justify-self: center;"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="closeChangeFotoDialog">{{
                        $t('homePassageiro.dialogs.changePhoto.cancel') }}</v-btn>
                    <v-btn color="primary" dark @click="saveNovaFoto">{{ $t('homePassageiro.dialogs.changePhoto.save')
                        }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <v-dialog v-model="mensagensDialog" width="80%" fullscreen>
            <v-card color="#cccdcf">
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ $t('homePassageiro.dialogs.messages.title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="closeMensagensDialog">mdi-close</v-icon>
                </v-toolbar>
                <v-card-text>
                    <v-list height="80vh" style="overflow-y: auto; width: 100%; background-color: transparent;">
                        <v-list-item v-for="(msg, m) in mensagens" :key="`${msg.id_mensagem}-${m}`"
                            style="margin-bottom: 10px;">
                            <mensagem-card :msg="msg" :color="msg.flag_mensagem_lida == 1 ? 'primary' : 'red'"
                                :caption="msg.dt_envio_extenso" @click="marcarMensagem(msg)"></mensagem-card>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn depressed color="transparent" @click="populaMensagensAntigas">{{
                        $t('homePassageiro.dialogs.messages.loadOldMessages') }}</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="qrcodeDialog" fullscreen>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ $t('homePassageiro.dialogs.qrcode.title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark color="primary" depressed @click="downloadQrCode">{{
                        $t('homePassageiro.dialogs.qrcode.download') }}</v-btn>
                    <v-btn dark color="primary" depressed @click="qrcodeDialog = false">{{
                        $t('homePassageiro.dialogs.qrcode.close') }}</v-btn>
                </v-toolbar>
                <v-card-text style="height: 80vh;">
                    <div style="height: 100%; align-self: center; align-content: center;">
                        <v-img :src="pessoa.qrcode_uri ? imgSrc + pessoa.qrcode_uri.substring('/static/'.length) : null"
                            height="400px" width="400px" min-height="70px" min-width="100px" lazy-src="mdi-qrcode"
                            style="padding: 10px; margin: 5px; justify-self: center;"></v-img>
                        <v-row justify="center" style="margin-top: 10px;">
                            <!-- <v-icon color="primary" style="margin-right: 10px;">mdi-chevron-left</v-icon> -->
                            <div>{{ pessoa.qrcode_no || pessoa.card_no }}</div>
                            <!-- <v-icon color="primary" style="margin-left: 10px;">mdi-chevron-right</v-icon> -->
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-card>
            <v-card-title color="primary">
                <div>{{ $t('homePassageiro.forms.personInfo.title') }}</div>
                <v-spacer></v-spacer>
                <v-badge color="error" overlap left>
                    <template v-slot:badge>
                        <span>{{ totalMensagensNovas }}</span>
                    </template>
                    <v-icon color="primary" @click="openMensagensDialog" style="margin-right: 10px;"
                        large>mdi-message-text</v-icon>
                </v-badge>

                <v-btn fab color="primary" small dark @click="qrcodeClicked"><v-icon>mdi-qrcode</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <!-- <v-col cols="12" sm="12" md="2">
                        <v-img :src="profilePicData || '/imagens/placeholder.png'" height="200px" width="200px"
                            min-height="100px" min-width="100px" lazy-src="/imagens/placeholder.png"
                            style="padding: 10px; margin: 5px; border: 1px solid #4a4a4a; border-radius: 5px; box-shadow: #4a4a4a 1px 1px 5px; cursor: pointer;"
                            @click="changeFotoDialog = true"></v-img>
                    </v-col> -->
                    <v-col cols="12" sm="12" md="12">
                        <v-form ref="formPessoa" v-model="formPessoaValidado">
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <div class="text-h6">{{ nomeCompletoFormatado }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <div class="text-subtitle-1">{{ pessoa.nome_grupo }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <div class="text-subtitle-2">{{ pessoa.nome_situacao_ativa }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <div class="text-subtitle-2">
                                        {{ $t('validationSituation.headers.situation') }}:
                                        {{ pessoa.nome_situacao_validacao || $t('validationSituation.notValidated') }}
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field v-model="pessoa.telefone" solo type="phone"
                                        v-mask="'(##) ## #####-####'"
                                        :label="$t('homePassageiro.forms.personInfo.fields.phone')"
                                        hint="(XX) XX XXXXX-XXXX" prepend-inner-icon="mdi-cellphone"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field v-model="pessoa.email" solo type="email"
                                        :label="$t('homePassageiro.forms.personInfo.fields.email')"
                                        :hint="$t('homePassageiro.forms.personInfo.fields.emailHint')"
                                        prepend-inner-icon="mdi-email"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="savePessoa">{{ $t('homePassageiro.forms.personInfo.save') }}</v-btn>
            </v-card-actions>
        </v-card>
        <v-card style="margin-top: 10px">
            <v-card-title color="primary">
                {{ $t('homePassageiro.forms.loginInfo.title') }}
            </v-card-title>
            <v-card-text>
                <v-form ref="formLogin" v-model="formLoginValidado">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field outlined readonly :value="pessoa.login"
                                :label="$t('homePassageiro.forms.loginInfo.fields.login')"
                                :disabled="true"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="novaSenha" outlined
                                :label="$t('homePassageiro.forms.loginInfo.fields.newPassword')"
                                :append-icon="showSenha ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showSenha ? 'text' : 'password'" :rules="[senhaRules]"
                                @click:append="showSenha = !showSenha"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="repetirSenha" outlined
                                :label="$t('homePassageiro.forms.loginInfo.fields.confirmPassword')"
                                :append-icon="showRepetirSenha ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showRepetirSenha ? 'text' : 'password'" :disabled="confirmarSenhaDisabled"
                                :rules="[repetirSenhaRules]"
                                @click:append="showRepetirSenha = !showRepetirSenha"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="saveLogin">{{ $t('homePassageiro.forms.loginInfo.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import { ApiBaseUrl } from "@/constants";
import MensagemCard from "./Cards/MensagemCard.vue";
import DateUtils from "../utils/dateutils";
import EventBus from "@/utils/eventBus";

export default {
    components: {
        MensagemCard
    },
    data: () => ({
        qrcodeDialog: false,
        changeFotoDialog: false,
        novaFoto: null,
        novaFotoFile: null,
        user: null,
        token: null,
        pessoa: {
            id_pessoa: null,
            nome: null,
            sobrenome: null,
            cpf: null,
            nome_completo: null,
            id_grupo: null,
            nome_grupo: null,
            nome_situacao_ativa: null,
            nome_situacao_validacao: null,
            telefone: null,
            img_uri: null,
            id_usuario: null,
            login: null,
            cod_integracao_faceid: null,
            qrcode_uri: null,
            qrcode_no: null,
        },
        novaSenha: null,
        repetirSenha: null,
        showSenha: false,
        showRepetirSenha: false,
        formLoginValidado: false,
        formPessoaValidado: false,
        profilePicData: null,
        mensagensDialog: false,
        mensagensAntigas: [],
        mensagensNovas: [],
        mensagensTimeout: null,
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user")).id_usuario;
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    computed: {
        confirmarSenhaDisabled() {
            return !this.novaSenha || this.novaSenha.length === 0;
        },
        imgSrc() {
            return `${ApiBaseUrl}/`;
        },
        nomeCompletoFormatado() {
            if (!this.pessoa.nome_completo) {
                return null;
            }

            let fNome = "";
            this.pessoa.nome_completo.split(" ").forEach((s) => {
                fNome += s.charAt(0).toUpperCase() + s.substring(1) + " ";
            });
            return fNome;
        },
        totalMensagensNovas() {
            return this.mensagensNovas.length;
        },
        mensagens() {
            return [...this.mensagensNovas, ...this.mensagensAntigas];
        }
    },
    methods: {
        initialize() {
            apiController.request(apiController.endpoints.getPessoaporusuario, {
                params: { id: this.user },
                onSuccess: (response) => {
                    this.pessoa = Object.assign({}, response.data[0]);
                    if (this.pessoa) {
                        if (this.pessoa.telefone) {
                            this.pessoa.telefone = `(${this.pessoa.telefone.substring(0, 2)}) ${this.pessoa.telefone.substring(2, 3)} ${this.pessoa.telefone.substring(3, 7)}-${this.pessoa.telefone.substring(7)}`;
                        }
                        // this.getProfilePic();
                        this.populaMensagensNovas();
                    }
                },
            });
        },
        // getProfilePic() {
        //     axios
        //         .get(ApiBaseUrl + "/api/v1.0/getfotoprincipal/" + this.pessoa.id_pessoa, {
        //             headers: { "x-access-token": this.token }
        //         })
        //         .then((response) => {
        //             this.profilePicData = response.data.foto;
        //         })
        //         .catch((e) => {
        //             EventBus.$emit('show-error', { error: e });
        //         });
        // },
        populaMensagensNovas() {
            apiController.request(apiController.endpoints.getMensagensnaolidaspordestinatario, {
                params: { id: this.pessoa.id_pessoa },
                onSuccess: (response) => {
                    this.mensagensNovas = response.data;
                    if (this.mensagensTimeout) {
                        clearTimeout(this.mensagensTimeout);
                    }
                    this.mensagensTimeout = setTimeout(this.populaMensagensNovas, 60000);
                },
            });
        },
        populaMensagensAntigas() {
            let dt;
            if (this.mensagensAntigas.length === 0) {
                dt = DateUtils.getDateSQLFormatted(new Date());
            } else {
                dt = this.mensagensAntigas[this.mensagensAntigas.length - 1].dt_envio;
            }

            apiController.request(apiController.endpoints.getMensagenspordestinatariolazy, {
                params: { id: this.pessoa.id_pessoa, dt: dt },
                onSuccess: (response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((m) => {
                            if (this.mensagensNovas.findIndex((e) => e.id_envio == m.id_envio) === -1) {
                                this.mensagensAntigas.push(...response.data);
                            }
                        })
                    }
                },
            });
        },
        saveLogin() {
            this.$refs.formLogin.validate();
            if (this.formLoginValidado) {
                apiController.request(apiController.endpoints.alteraSenha, {
                    data: {
                        id_usuario: this.user,
                        senha: this.novaSenha,
                        repetirsenha: this.repetirSenha
                    },
                    silent: true,
                    onSuccess: (response) => {
                        EventBus.$emit('show-alert', {
                            mensagem: response.data.mensagem,
                            tipo: response.data.erro ? 'error' : 'success'
                        });
                        this.novaSenha = null;
                        this.repetirSenha = null;
                        this.$refs.formLogin.resetValidation();
                    },
                    onError: (e) => {
                        console.log(e);
                        this.sysError = e;
                        this.authDialog = true;
                    },
                });
            }
        },
        savePessoa() {
            this.$refs.formPessoa.validate();
            if (this.formPessoaValidado) {
                this.pessoa.telefone = this.pessoa.telefone.replaceAll(/[^\d]/g, '');
                apiController.request(apiController.endpoints.updatePessoa, {
                    data: this.pessoa,
                    silent: true,
                    onSuccess: (response) => {
                        EventBus.$emit('show-alert', {
                            mensagem: response.data.mensagem,
                            tipo: response.data.erro ? 'error' : 'success'
                        });
                        this.$refs.formPessoa.resetValidation();
                        this.initialize();
                    },
                    onError: (e) => {
                        console.log(e);
                        this.sysError = e;
                        this.authDialog = true;
                    },
                });
            }
        },
        senhaRules() {
            if (!this.novaSenha || this.novaSenha.length === 0) {
                return this.$t('homePassageiro.validation.passwordRequired');
            } else {
                if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/.test(this.novaSenha)) {
                    return this.$t('homePassageiro.validation.passwordComplexity');
                } else {
                    return true;
                }
            }
        },
        repetirSenhaRules() {
            if (this.novaSenha !== this.repetirSenha) {
                return this.$t('homePassageiro.validation.passwordsNotMatch');
            }

            return true;
        },
        closeChangeFotoDialog() {
            this.novaFoto = null;
            this.novaFotoFile = null;
            this.changeFotoDialog = false;
        },
        onFileChanged() {
            if (this.novaFotoFile) {
                const reader = new FileReader();
                reader.onload = e => {
                    this.novaFoto = e.target.result
                };
                reader.readAsDataURL(this.novaFotoFile);
            } else {
                this.novaFoto = null;
            }
        },
        saveNovaFoto() {
            if (this.novaFotoFile && this.novaFoto) {
                let payload = {
                    files: JSON.stringify([{ filename: this.novaFotoFile.name.split('.')[0], imgData: this.novaFoto }]),
                    folder: `fotos/${this.pessoa.cpf}`,
                    cpf: this.pessoa.cpf,
                    img_uri: null,
                    cod_integracao_faceid: this.pessoa.cod_integracao_faceid
                }

                apiController.request(apiController.endpoints.uploadImgbulk, {
                    data: payload,
                    silent: true,
                    onSuccess: (response) => {
                        EventBus.$emit('show-alert', {
                            mensagem: response.data.files[0].message,
                            tipo: response.data.files[0].error ? 'error' : 'success'
                        });
                        this.closeChangeFotoDialog();
                        this.initialize();
                    },
                    onError: (e) => {
                        console.log(e);
                        this.sysError = e;
                        this.authDialog = true;
                    },
                });
            }
        },
        downloadQrCode() {
            apiController.request(apiController.endpoints.downloadQrcode, {
                data: { id_usuario: this.user, id_pessoa: this.pessoa.id_pessoa, qrcode_no: this.pessoa.qrcode_no },
                config: { responseType: "blob" },
                onSuccess: (response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", this.pessoa.qrcode_no + "-qr.png"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
            });
        },
        openMensagensDialog() {
            this.mensagensDialog = true;
        },
        closeMensagensDialog() {
            this.mensagensDialog = false;
        },
        marcarMensagem(msg) {
            msg.flag_mensagem_lida = 1;

            apiController.request(apiController.endpoints.updateEnviomensagem, {
                data: msg,
                onSuccess: (response) => {
                    console.log(response.data);
                    this.populaMensagensNovas();
                },
            });
        },
        qrcodeClicked() {
            this.qrcodeDialog = true;
            if (this.pessoa.qrcode_no) {
                apiController.request(apiController.endpoints.updateAcessoqrcode, {
                    data: { id_usuario: this.user, id_pessoa: this.pessoa.id_pessoa },
                    onSuccess: (response) => {
                        console.log(response.data);
                    },
                });
            }
        },
    },
}
</script>

<style></style>